import { render, staticRenderFns } from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=template&id=3d5c167c&scoped=true"
import script from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c167c",
  null
  
)

export default component.exports